module.exports = __webpack_public_path__ + "static/media/Next.e85e1b4e.svg";